import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment.demo';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
loadingSpinner: boolean = false;
faqDetails = [];
image = "../../../assets/theme/img/helpBanner.png"
bannerTitle = "Help";
  apiTimer: any;

  requesttoken: SilentRequest = {
    scopes: [environment.clientId + '/user.read'],
    account: undefined,
    // account: this.msalService.instance.getAllAccounts()[0]
  };

  constructor(private _appService : AppService, private location: Location,private authService: MsalService) { }

  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
        this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
          // console.log("SilentToken FaqComponent...", result);
          sessionStorage.setItem('accessToken', result.accessToken);
          this._appService.jwtAuthorizationToken=result.accessToken;
          this.getFaqData()
        })

    window.scroll(0,0);
   }

   getFaqData(){
    this.apiTimer = setInterval(()=>{
    this._appService.getFaqPagedetails().subscribe(res => {
      this.faqDetails = res;
      if(this.faqDetails){
        clearInterval(this.apiTimer);
      }
    })
  },2000);
  }

  onBackClick(){
    this.location.back();
  }
}
